import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NavbarComponent } from './core/navbar/navbar.component';
import { FooterComponent } from './core/footer/footer.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NavbarComponent, FooterComponent, RouterOutlet],
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'public';

  constructor(private meta: Meta, private translateService: TranslateService) {}

  ngOnInit(): void {
    if (document.getElementsByClassName('fareharbor-calendar-wrap')[0]) {
      let fareharbor = document.getElementsByClassName(
        'fareharbor-calendar-wrap'
      )[0];
      (fareharbor as any).style.display = 'none';
    }

    if (environment.noIndex) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }
}
